import { weights } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

interface Props {
  watermark?: string;
  className?: string;
}

export function Watermark(props: PropsWithChildren<Props>) {
  const { className, children, watermark } = props;

  return (
    <div className={styles.positionRelative}>
      {watermark && (
        <div className={css(styles.watermark, className)}>{watermark}</div>
      )}
      <div className={styles.positionRelative}>{children}</div>
    </div>
  );
}

const styles = {
  positionRelative: css({
    position: "relative",
  }),
  watermark: css({
    position: "absolute",
    top: "50%",
    left: "50%",
    fontWeight: weights["font-weight-semibold"],
    transform: "translate(-50%, -50%) rotate(-30deg)",
    fontSize: "80px",
    color: "var(--background-accent-neutral-weakest)",
    pointerEvents: "none",
  }),
};
